import TanStackTable from "root/TanstackTables/TanStackTable";


const LJAppUsageTable = ({data}) =>
{
    const columns = [
        {accessorKey: 'school_name', header: 'School', enableSorting: true},
        {accessorKey: 'distinct_users', header: 'Distinct Users', enableSorting: true, meta: {textAlign: 'center'}},
        {accessorKey: 'total_usages', header: 'Total Usages', enableSorting: true, meta: {textAlign: 'center'}},
    ];

    return (
        <div className='lj-app-usage-table' key='ljAppUsageTable'>
            <TanStackTable data={data} columns={columns} showSearch={true}/>
        </div>
    )
}

export default LJAppUsageTable;
